import { Component, OnInit, OnDestroy } from '@angular/core';
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth';
import { NbDialogService } from '@nebular/theme';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TokenPayload } from '../../../shared/models/token-payload.model';
import { LogoutConfirmationDialogComponent } from '../../components/logout-confirmation-dialog/logout-confirmation-dialog.component';
import { KlientService } from '../../../@core/http/klient.service';
import { Klient } from '../../../shared/models/klient.model';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout [class.sidebar-open-desktop]="isMainSidebarOpen && !isMobile">
      <nb-layout-header fixed>
        <ngx-header 
          [isMainSidebarOpen]="isMainSidebarOpen"
          [klient]="klient"
          (onSidebarToggle)="toggleMainSidebar()">
        </ngx-header>
      </nb-layout-header>

      <nb-layout-column [class.content-with-sidebar]="isMainSidebarOpen && !isMobile">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed [class.footer-with-sidebar]="isMainSidebarOpen && !isMobile">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>

    <ngx-main-menu-sidebar 
      [isOpen]="isMainSidebarOpen"
      [user]="user"
      (onClose)="closeMainSidebar()"
      (onLogout)="confirmLogout()">
    </ngx-main-menu-sidebar>
  `,
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy {
  isMainSidebarOpen = false;
  
  user: TokenPayload;
  klient: Klient;
  
  private destroy$ = new Subject<void>();

  constructor(
    private authService: NbAuthService,
    private dialogService: NbDialogService,
    private router: Router,
    private klientService: KlientService
  ) {}

  ngOnInit() {
    this.authService.onTokenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe((token: NbAuthOAuth2JWTToken) => {
        if (token.isValid()) {
          this.user = token.getAccessTokenPayload();
        }
      });

    this.klientService.getKlient()
      .pipe(takeUntil(this.destroy$))
      .subscribe(klient => {
        this.klient = klient;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  toggleMainSidebar() {
    this.isMainSidebarOpen = !this.isMainSidebarOpen;
  }

  closeMainSidebar() {
    this.isMainSidebarOpen = false;
  }

  confirmLogout() {
    this.dialogService.open(LogoutConfirmationDialogComponent)
      .onClose.subscribe(confirmed => {
        if (confirmed) {
          this.authService.logout('email').subscribe(result => {
            if (result.isSuccess()) {
              this.router.navigate(['/auth/login']);
            }
          });
        }
      });
  }
}
